import axios from 'axios';

const getCardDetails = (cardLabel) => {
    return axios.get(`/api/pttpilot/${cardLabel}`)
        .then(res => {return res.data})
}

const getOtherVisits = (cardLabel) => {
    return axios.get(`/api/pttpilot/getothervisits/${cardLabel}`)
        .then(res => {return res.data});
}

const prevStep = (cardLabel) => {
    return axios.patch(`/api/pttpilot/LogVisitPrevStep/${cardLabel}`, {})
        .then(res => {return res.data});
}

const nextStep = (cardLabel) => {
    return axios.patch(`/api/pttpilot/LogVisitNextStep/${cardLabel}`, {})
        .then(res => {return res.data});
}

const closeVisit = (cardLabel) => {
    return axios.patch(`/api/pttpilot/CloseVisit/${cardLabel}`, {})
        .then(res => {return res.data});
}

const resetCurrentStep = (cardLabel) => {
    return axios.get(`/api/pttpilot/ResetCurrentStep/${cardLabel}`)
        .then(res => {return res.data})
}

export const dynamicRequest = (url) => {
    return axios.get(url)
        .then(res => { return res.data })
}

const loginService = (email = "superadmin", password = "123") => {
    return axios.post('/api/account/login', { email: email, password: password })
        .then(
            res => {
                return res.data.token
            },
            error => {
                return error
            }
        )
}

export const dynamicRequestWithAutorize = (url) => {
    return loginService()
        .then(
            (res) => {
                return axios.get(url,{ headers: { Authorization: 'Bearer ' + res } })
                    .then(res => { return res.data })
            }
        )
}


export const pilotService = {
    getCardDetails,
    getOtherVisits,
    prevStep,
    nextStep,
    closeVisit,
    resetCurrentStep,
    dynamicRequest
}
